let $ = require("jquery");
let Backbone = require("backbone");
import POS from "../../POS.js";
let _ = require("underscore");
let i18n = require("../../utils/i18n");

let main = function ($, Backbone, POS, _, i18n) {
    return Backbone.View.extend({
        events: {
            "click": "_onClick",
            "keyup": "_onKey",
            "keydown .number-input": "_onKeyDown",
            "keyup .number-input": "_onKeyUp",
            "click .num": "_onNumberPress",
            "click .point": "_onPointPress",
            "click .minus": "_onMinusPress",
            "touchstart .backspace": "_onBackspaceDown",
            "touchend .backspace": "_onBackspaceUp",
            "mousedown .backspace": "_onBackspaceDown",
            "mouseup .backspace": "_onBackspaceUp"
        },
        initialize: function () {
            var self = this;
            self.model.on("change:title", self._onTitleChange, self);
            self.model.on("change:numberInput", self._onNumberInputChange, self);
            self.model.on("change:targetChange", self._onTargetChange, self);
            self.model.on("change:number", self._onNumberChange, self);
            self.initializeTarget();
            if (!self.model.get("numberInput")) {
                self.model.set({numberInput: "0"});
            }
            // self.$(".backspace").tooltip();
        },
        initializeTarget: function () {
            var self = this, data = self.$el.data(), container, target;
            container = self.$el.closest(data.closest);
            if (container.length > 0) {
                target = container.find(data.targets + "." + data.selected);
                if (target.length == 0) {
                    target = container.find(data.targets).first();
                    target.addClass(data.selected);
                }
                self.changeTarget(target);
            }
        },
        clearTarget:function(){
            this.target = null;
            $(".mode").removeClass("selected").find(".num").text("");
            this.model.set({numberInput: 0,  num: parseFloat(0)});
        },
        changeTarget: function (target, membership, leftPay) {
            var self = this, data = self.$el.data();
            if (self.target) {
                self.target.removeClass(data.selected);
            }
            self.target = target;
            target.addClass(data.selected).siblings().removeClass(data.selected);
            self.model.set({targetChange: true});
            self.click();
            if (membership) {
                target.find(".member").text(membership.fullname);
            } else {
                target.find(".member").text("");
            }
        },
        unsetTarget: function () {
            var self = this;
            self.initializeTarget();
        },
        click: function () {
            var self = this;
            self.$el.click();
        },
        _focusNumberInput: function () {
            var self = this;
            self.$(".number-input").focus();
        },
        clear: function () {
            this.$(".num-display").text("0");
            this.model.set({number: new Number(0)});
        },
        _onClick: function () {
            var self = this;
            self._focusNumberInput();
        },
        _onKey: function (event) {
            console.log(event.keyCode);
        },
        _onKeyDown: function (event) {
            var self = this, keyCode = event.keyCode;
            if (keyCode == 8) {
                self._onBackspaceDown();
                return false;
            }

            return true;
        },
        _onKeyUp: function (event) {
            var self = this, keyCode = event.keyCode, data = self.$el.data(), nextTarget;

            if (keyCode == 8) {
                self._onBackspaceUp();
                return false;
            }
            if (keyCode > 47 && keyCode < 58) {
                self.$(".num[data-number=" + (keyCode - 48) + "]").click();
                return false;
            }
            if (keyCode > 95 && keyCode < 106) {
                self.$(".num[data-number=" + (keyCode - 96) + "]").click();
                return false;
            }
            if (keyCode === 190 || keyCode === 110) {
                self.$(".point").click();
                return false;
            }
            if (keyCode === 189 || keyCode === 109) {
                self.$(".minus").click();
                return false;
            }
            if (self.target) {
                if ((keyCode === 38) || (keyCode === 37)) {
                    nextTarget = self.target.prev();
                    while (nextTarget && nextTarget.hasClass("block-arrow")) {
                        nextTarget = nextTarget.prev();
                    }
                }
                if ((keyCode === 40) || (keyCode === 39)) {
                    nextTarget = self.target.next();
                    while (nextTarget && nextTarget.hasClass("block-arrow")) {
                        nextTarget = nextTarget.next();
                    }
                }
                if (nextTarget && nextTarget.length > 0) {
                    self.changeTarget(nextTarget);
                    return false;
                }
            }

            return true;
        },


        _onNumberPress: function (event) {
            event.stopPropagation();
            var self = this, target = $(event.currentTarget), number = self.model.get("numberInput");
            if (number !== "0") {
                number = number + target.data("number");
            } else {
                number = target.data("number");
            }
            //如果金额大于100,000,000
            if (number > 100000000) {
                alert(i18n.msg("pos.enter.number.too.large"));
                return
            }
            self.model.set({numberInput: number});
            self._focusNumberInput();
            target.addClass("touched");
            _.delay(function () {
                target.removeClass("touched");
            }, 250);
        },
        _onPointPress: function (event) {
            var self = this, numberInput = self.model.get("numberInput");
            if ((typeof numberInput) !== 'string') {
                numberInput = numberInput.toString();
            }
            if (numberInput.toString().contains('.')) {
                return;
            }
            numberInput = numberInput + ".";
            self.model.set({numberInput: numberInput});
            self._focusNumberInput();
        },
        _onMinusPress: function (event) {
            var self = this, numberInput = self.model.get("numberInput");
            if ((typeof numberInput) !== 'string') {
                numberInput = numberInput.toString();
            }
            if (numberInput.indexOf("-") == 0) {
                numberInput = numberInput.substring(1);
            } else {
                numberInput = "-" + numberInput;
            }
            self.model.set({numberInput: numberInput});
            self._focusNumberInput();
        },
        _onTitleChange: function () {
            var self = this;
            self.$(".title").text(self.model.get("title"));
        },
        _onBackspaceDown: function () {
            var self = this, minusTime = self.model.get("minusTime");
            if (minusTime === undefined || !minusTime) {
                self.model.set({minusTime: new Date().getTime()});
            }
        },
        _onBackspaceUp: function () {
            var self = this, numberInput = self.model.get('numberInput'), minusTime = self.model.get("minusTime"), now = new Date().getTime();
            if ((typeof numberInput) !== 'string') {
                numberInput = numberInput.toString();
            }
            if (now - minusTime > 350) {
                self.model.set({numberInput: "0"});
            } else {
                self.model.set({numberInput: numberInput.substring(0, numberInput.length - 1)});
            }
            self.model.set({minusTime: 0});
        },
        _onNumberInputChange: function (event) {
            var self = this, numberInput = self.model.get('numberInput');
            if ((typeof numberInput) !== 'string') {
                numberInput = numberInput.toString();
            }
            self.$(".num-display").text(numberInput);
            if (numberInput === ".") {
                numberInput = "0";
            } else if (numberInput === '-') {
                numberInput = '0';
            } else if (numberInput.indexOf(".") == 0) {
                numberInput = "0" + numberInput
            } else if (numberInput.match(/\.$/)) {
                numberInput = numberInput + "0";
            }
            self.model.set({number: new Number(numberInput)});
        },
        _onNumberChange: function () {
            var self = this, number = self.model.get("number"), type = self.model.get('type');
            self.model.set({numberInput: number.toString()}, {silence: true});
            if (self.target) {
                switch (type) {
                    case "mutual":
                        self.target.find(".num").text(number.toFixed(2));
                        break;
                    case "retrieve":
                        self.target.find(".num").text(number.toFixed(2));
                        break;
                    default:
                        break;
                }
            }
        },
        _onTargetChange: function () {
            var self = this, type = self.model.get('type'), title = self.target.data("title"), num = self.target.find(".num").text();
            if ((typeof num) !== 'string') {
                num = num.toString();
            }
            if (num == "") {
                num = "0";
            }
            if (num.match(/\.00$/)) {
                num = num.substring(0, num.length - 3);
            }
            self.model.set({targetChange: false}, {silence: true});
            if (self.target) {
                switch (type) {
                    case "mutual":
                        self.model.set({numberInput: num, title: title});
                        break;
                    case "set":
                        self.model.set({numberInput: num, title: title});
                        break;
                    default:
                        break;
                }
            }
        }
    })
};

let exportedValue = main($, Backbone, POS, _, i18n);
export default exportedValue;




// WEBPACK FOOTER //
// ./src/view/comp/NumberPadView.js